import { Injectable } from '@angular/core';
import { InspectionFactoryService } from '../../shared/services/inspectionFactory.service';
import { IndexedDbService } from '../../shared/services/indexedDb.service';
import { Observable } from 'rxjs';
import { InspectionPlugin } from '../../shared/models';
import { DataService } from '../../shared/services';

@Injectable()
export class CustomerRemarkFactoryService extends InspectionFactoryService {
  constructor(indexedDb: IndexedDbService, dataService: DataService) {
    super(indexedDb, dataService);
  }

  public updateComment(
    inspectionId: string,
    pointId: string,
    pluginId: string,
    remarks: any[],
    propertyName?: string
  ): Observable<InspectionPlugin> {
    remarks.forEach((r) => {
      if (!r.Id) {
        r.Id = this.guid();
      }
    });
    return this.updatePluginConfig(inspectionId, pointId, pluginId, remarks, propertyName);
  }
}
